import React, { Component } from "react";
import { getFieldOfMedicine } from "../../../store/actions";
// import Select from "../../../modules/react-select";
import Select from "../../../modules/react-select-plus";
import "react-select-plus/dist/react-select-plus.css";

class FieldOfMedicine extends Component {
  constructor(props) {
    super(props);
    let fieldOfMedicine = "";
    if (this.props.selectedValue) {
      fieldOfMedicine = {
        value: this.props.selectedValue,
        label: this.props.selectedValue,
      };
    }
    this.state = {
      fieldOfMedicineOptions: [],
      isFocused: props.hasOwnProperty("isFocused") ? true : false,
      isOpenDropdown: false,
      fieldOfMedicine: fieldOfMedicine,
      showLabel: props.hasOwnProperty("showLabel") ? false : true,
    };
  }

  async componentDidMount() {
    let fieldOfMedicine = await getFieldOfMedicine();
    let fieldOfMedicineOptions = [];
    const getChild = (med, obj) => {
      debugger
      // if (med && med?.length > 0) {
      //   med.forEach((ele, index) => {
      //     let obj1 = {
      //       label: ele.name,
      //       //value: ele.display,
      //       options: [],
      //     };

      //     obj1 = getChild(ele, obj1);
      //     obj.options.push(obj1);
      //   });
      //   return obj;
      // } else if (med && med.services && med.services?.length > 0) {
        med.services.forEach((ele, index) => {
          obj.options.push({
            label: ele.name,
            value: ele.name,
          });
        });
        return obj;
      // } else {
      //   return obj;
      // }
    };

    const deleteBlankArray = (fieldOfMedicine) => {
      fieldOfMedicine?.length &&
        fieldOfMedicine.forEach((ele) => {
          if (ele.options && ele.options?.length === 0) {
            delete ele.options;
          } else {
            return deleteBlankArray(ele.options);
          }
        });
      return fieldOfMedicine;
    };
    fieldOfMedicine?.length &&
      fieldOfMedicine.forEach((medl1) => {
        let obj = {
          label: medl1.name,
          //value: medl1.display,
          options: [],
        };
        obj = getChild(medl1, obj);
        fieldOfMedicineOptions.push(obj);
      });

    fieldOfMedicine = deleteBlankArray(fieldOfMedicineOptions);

    this.setState({
      fieldOfMedicineOptions: fieldOfMedicineOptions,
    });
  }

  // handleFieldOfMedicianSelected(select, e) {
  //     e.stopPropagation();
  //     this.setState({
  //         fieldOfMedicine: select,
  //         isOpenDropdown: false
  //     }, () => {
  //         if(this.props.selectFieldOfMedicine && typeof this.props.selectFieldOfMedicine === "function") {
  //             this.props.selectFieldOfMedicine(this.state.fieldOfMedicine)
  //         }
  //     })
  // }

  // handleMedicienClick(val, e) {
  //     e.stopPropagation();
  //     let id = e.target.id;
  //     id = id.split("-");
  //     id = id.map((el) => parseInt(el))
  //     let { fieldOfMedicineOptions, fieldOfMedicine } = this.state;
  //     let dropdownSelected = false;
  //     console.log("Id: ", id, val)
  //     if(val && val.concept && val.concept.length > 0) {
  //         console.log("111111");
  //         if(id.length === 1) fieldOfMedicineOptions[id[0]].isOpen = !(fieldOfMedicineOptions[id[0]].isOpen);
  //         if(id.length === 2) fieldOfMedicineOptions[id[0]].concept[id[1]].isOpen = !(fieldOfMedicineOptions[id[0]].concept[id[1]].isOpen);
  //     } else if(val && val.designation && val.designation.length > 0) {
  //         console.log("222222");
  //         if(id.length === 1) fieldOfMedicineOptions[id[0]].isOpen = !(fieldOfMedicineOptions[id[0]].isOpen);
  //         if(id.length === 2) fieldOfMedicineOptions[id[0]].concept[id[1]].isOpen = !(fieldOfMedicineOptions[id[0]].concept[id[1]].isOpen);
  //     } else {
  //         console.log("33333");
  //         fieldOfMedicine = val.display;
  //         dropdownSelected = true
  //     }
  //     this.setState({
  //         fieldOfMedicine,
  //         fieldOfMedicineOptions,
  //         isOpenDropdown: dropdownSelected ? false : true
  //     }, ()=> {
  // if(this.props.selectFieldOfMedicine && typeof this.props.selectFieldOfMedicine === "function") {
  //     this.props.selectFieldOfMedicine(this.state.fieldOfMedicine)
  // }
  //     })
  // }

  // renderChilds(medL1, index, indexString) {
  //     let level = indexString.split("-").length;
  //     level = level+1;
  //     let ulClassName = "med-comp-ul" + level
  //     if(medL1 && medL1.designation && medL1.designation.length > 0) {
  //         return <ul
  //                 // className={medL1.isOpen ? `${ulClassName}` : `d-none ${ulClassName}`}
  //                 className={`${ulClassName}`}
  //             >
  //             {
  //                medL1.designation.map((des, dIndex) => {
  //                    return <li
  //                     onClick={this.handleFieldOfMedicianSelected.bind(this, des.value)}
  //                     key={`${indexString}-${dIndex}`}
  //                     className={`${indexString}-${dIndex}`}
  //                    >{des.value}
  //                 </li>
  //               })
  //             }
  //         </ul>

  //     } else if(medL1 && medL1.concept && medL1.concept.length > 0) {
  //         return <ul
  //             // className={medL1.isOpen ? `${ulClassName}` : `d-none ${ulClassName}`}
  //             className={`${ulClassName}`}
  //         >

  //             {
  //                medL1.concept.map((ele, index) => {
  //                    let id = indexString+ `-${index}`;
  //                    let haveMoreFields = false;
  //                     if(medL1.concept && medL1.concept.length > 0) {
  //                         haveMoreFields = true
  //                     } else if(medL1.designation && medL1.designation.length > 0) {
  //                         haveMoreFields = true
  //                     }
  //                    return <li
  //                         onClick={this.handleMedicienClick.bind(this, ele)}
  //                         id={id}
  //                         key={id}
  //                         // className={haveMoreFields ? "toggle-sign" : ""}
  //                    >
  //                     {ele.display}
  //                     {this.renderChilds(ele, index, id)}

  //                  </li>
  //               })
  //             }
  //         </ul>
  //     // }
  //     } else {
  //         return null
  //     }
  // }
  handleChange = (fieldOfMedicine) => {
    this.setState(
      {
        fieldOfMedicine:
          fieldOfMedicine && fieldOfMedicine.value ? fieldOfMedicine.value : "",
      },
      () => {
        if (
          this.props.selectFieldOfMedicine &&
          typeof this.props.selectFieldOfMedicine === "function"
        ) {
          this.props.selectFieldOfMedicine(this.state.fieldOfMedicine);
        }
      }
    );
  };

  render() {
    let { fieldOfMedicineOptions, fieldOfMedicine, showLabel } = this.state;
    var classes = ["input-div-1", "clinic-profile-signup"];
    if (this.state.isFocused) {
      classes.push("open");
    }

    return (
      <div className={showLabel ? classes.join(" ") : ""}>
        <h3
          className={`fom-label ${this.state.isFocused ? "fom-label-1" : ""}`}
        >
          {showLabel ? "Service Discipline*" : null}
        </h3>

        <Select
          name="fieldOfMedicine"
          value={fieldOfMedicine}
          onChange={this.handleChange}
          options={fieldOfMedicineOptions}
          searchable={true}
          clearable={true}
          placeholder="Service Discipline*"
          onFocus={() => {
            this.setState({
              isFocused: true,
            });
          }}
          onBlur={() => {
            this.setState({
              isFocused: false,
            });
          }}
          disabled={this.props.disabled || false}
          // isOpen={true}
        />

        {/* <Select */}
        {/* // valueArray={fieldOfMedicine}
          //onChange={this.handleChange}
          // searchable={true}
          // options={fieldOfMedicineOptions}
          //className="field-of-medicien"
          // placeholder="Field Of Medicine"
          // onFocus={() => { */}
        {/* //   this.setState({ */}
        {/* //     isFocused: true,
          //   });
          // }}
          // isDisabled={this.props.disabled || false}
          // menuIsOpen={true}
          // filterOption={createFilter()}
          // onInputChange={(event, value) => { */}
        {/* //     console.log("event", event)
          //     console.log("value", value)
          //     let { fieldOfMedicineOptions } = this.state;
          //     fieldOfMedicineOptions.splice(0, 1);
          //     this.setState({ */}
        {/* //       fieldOfMedicineOptions
          //     })
          // }}
          // ignoreAccents={false}
        ///> */}
        {/* <div onClick={()=> this.setState({isOpenDropdown: !isOpenDropdown})}>{fieldOfMedicine ? fieldOfMedicine : "Field Of Medicine"}</div>
                <ul 
                    className={isOpenDropdown ? "med-comp-ul1" : "d-none med-comp-ul1"}
                >
                    {
                        fieldOfMedicineOptions && fieldOfMedicineOptions.map((medL1, index) => {
                            let haveMoreFields = false;
                            if(medL1.concept && medL1.concept.length > 0) {
                                haveMoreFields = true
                            } else if(medL1.designation && medL1.designation.length > 0) {
                                haveMoreFields = true
                            }
                            return <li
                                value={medL1.display}
                                key={`medL1-${index}`}
                                id={`${index}`}
                                onClick={this.handleMedicienClick.bind(this, medL1)}
                                // className= {haveMoreFields ? medL1.isOpen ? "toggle-up" : "toggle-sign" : ""}
                            >
                                {medL1.display}
                                <br/>
                                {this.renderChilds(medL1, index, `${index}`)}
                            </li>
                        })
                    }
                </ul>
                {this.props.children} */}
      </div>
    );
  }
}

export default FieldOfMedicine;
